// Beta Report wording changes published from Admin → Beta Report Wording (2026-11-04).
// Also the admin's deleted and added questions (2026-11-04), applied by schema.setStructure.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ENGLISH, setPublishedWording } from "./i18n";
import { setStructure } from "./schema";

export const GROUPS = ["ui", "stages", "sections", "ratings", "q", "opt", "ph"];
// Not editable: these take numbers, and the mode names are fixed product names.
export const LOCKED = new Set(["ui.stage", "ui.charsLeft", "ui.modes"]);

// Every editable text key ("q.a_overall", "opt.yes", …), in the built-in order.
export function editableKeys() {
  const keys = [];
  for (const group of GROUPS) {
    for (const [id, value] of Object.entries(ENGLISH[group] || {})) {
      const key = `${group}.${id}`;
      if (typeof value === "string" && !LOCKED.has(key)) keys.push(key);
    }
  }
  return keys;
}

export function textAt(strings, key) {
  const [group, id] = key.split(".");
  return strings?.[group]?.[id];
}

let loading = null;
let version = 0;
let ready = false;
const listeners = new Set();

export function loadBetaReportWording({ force = false } = {}) {
  if (loading && !force) return loading;
  loading = api.get("/beta-report/wording")
    .then(({ data }) => {
      setPublishedWording(data?.text || {});
      setStructure(data?.structure || {});
      ready = true;
      version += 1;
      listeners.forEach((fn) => fn(version));
    })
    .catch(() => {
      // The built-in form still works; try again next time.
      loading = null;
      ready = true;
      version += 1;
      listeners.forEach((fn) => fn(version));
    });
  return loading;
}

// Re-renders the caller once the published wording has loaded; true once it has
// (or failed to load, when the built-in form is used).
export function useBetaReportWording() {
  const [v, setV] = useState(version);
  useEffect(() => {
    listeners.add(setV);
    loadBetaReportWording();
    return () => listeners.delete(setV);
  }, []);
  return v >= 0 && ready;
}
